import styles from '../styles/PCButton.module.scss';

interface ButtonSmallProps {
    label: string;
    color: string;
    onClick: () => void;
}

const PCButtonSmall: React.FC<ButtonSmallProps> = ({ label,color, onClick }) =>  {


    return (
        <div className={styles.ButtonSmall} onClick={onClick} style={{backgroundColor: color}}>
            {label}
        </div>
    );
}

export default PCButtonSmall;
